<template>
  <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-4">
    <div>
      <h1 class="text-2xl font-bold text-gray-900">{{ title }}</h1>
      <p v-if="description" class="mt-1 text-gray-500 text-sm">{{ description }}</p>
    </div>
    <div class="flex gap-2 items-center">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
import { onMounted, watch } from 'vue'

export default {
  name: 'PageTitle',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    appName: {
      type: String,
      default: 'SellHub'
    }
  },
  setup(props) {
    const setDocumentTitle = () => {
      if (typeof document !== 'undefined') {
        document.title = props.title ? `${props.title} | ${props.appName}` : props.appName
      }
    }

    onMounted(setDocumentTitle)
    watch(() => props.title, setDocumentTitle)

    return {}
  }
}
</script>
